import { Masonry } from "@mui/lab";
import { Box } from "@mui/material";
import { useState } from "react";
import { SmsCampaignDto } from "../../../api/psc";
import SmsCampaignItem from "./SmsCampaignItem";

// updated
export default function Index(props: { smsCampaigns: SmsCampaignDto[] }) {
    const [open, setOpen] = useState(false);
    const handleCloseModal = () => {
        setOpen(false);
    };

    return (
        <Box sx={{ overflow: "hidden" }}>
            <Box sx={{ marginRight: "-16px", px: "2px" }}>
                <Masonry
                    columns={{ xl: 4, lg: 4, md: 3, sm: 2, xs: 1 }}
                    spacing={2}
                >
                    {props.smsCampaigns.map((c) => {
                        return (
                            <SmsCampaignItem
                                key={c.id}
                                smsCampaign={c}
                            ></SmsCampaignItem>
                        );
                    })}
                </Masonry>
            </Box>
        </Box>
    );
}
